module.exports = __webpack_public_path__ + "static/media/card.0a2eb4b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/card.png
// module id = 1329
// module chunks = 0